<template>
  <div v-show="dialogVisible">
    <el-dialog
      :title="title"
      align="center"
      :visible.sync="dialogVisible"
      top="5vh"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
    >
      <div class="media-box" id="media-box" v-if="videoShow"></div>
      <div class="media-box" id="img-box" v-if="imgShow">
        <decrypt-img :src="mediaUrl" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import baseConfig from "@/utils/serverUrlConfig";
import previewImages from "../utils/previewImages";
export default {
  data() {
    return {
      dialogVisible: false,
      imgShow: true,
      mediaUrl: "",
      videoShow: false,
      title: "封面图查看",
      myData: []
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      if (this.player) {
        this.player.dispose();
      }
      this.dialogVisible = false;
      this.imgShow = false;
      this.videoShow = false;
      this.mediaUrl = "";
    },
    open(url, type) {
      if (type === "img") {
        // this.imgShow = true;
        // this.videoShow = false;
        // this.title = "封面图查看";
        // this.mediaUrl = url;
        previewImages([url]);
      } else {
        this.dialogVisible = true;
        this.imgShow = false;
        this.videoShow = true;
        this.title = "视频查看";
        this.mediaUrl =
          baseConfig.baseServerUrl +
          baseConfig.playVideoUrl +
          url +
          "?token=" +
          this.token;
        this.$nextTick(function() {
          document.getElementById("media-box").innerHTML =
            '<video id="my-video"  class="video-js vjs-default-skin" controls preload="auto" style="width:100%;height:100%"></video>';
          this.player = videojs(
            "my-video",
            {
              bigPlayButton: false,
              textTrackDisplay: false,
              posterImage: true,
              errorDisplay: true,
              controlBar: true
            },
            function() {
              this.play();
            }
          );
          this.player.src(this.mediaUrl);
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.my_data {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

#media-box {
  height: 400px;
}

.media-box {
  width: 100%;
  // height: 400px;
  text-align: center;
  overflow: hidden;
  img {
    height: auto;
    max-width: 100%;
  }
  #my-video {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }
}
</style>